import React, { useState, useEffect } from 'react';

const REGIMES = [
    { key: 'TRENDING_UP',     label: 'Tendência ↑',  hint: 'Alta forte — tamanho máximo' },
    { key: 'RANGING',         label: 'Lateral',       hint: 'Neutro — tamanho moderado' },
    { key: 'HIGH_VOLATILITY', label: 'Alta Vol.',     hint: 'Volátil — reduzir risco' },
    { key: 'TRENDING_DOWN',   label: 'Tendência ↓',  hint: 'Baixa — mínimo ou pular' },
];

const EMPTY = { TRENDING_UP: '', RANGING: '', HIGH_VOLATILITY: '', TRENDING_DOWN: '' };

/**
 * props:
 * - regimeSizing  (JSON string or null)
 * - onChange(event: { target: { id: 'regimeSizing', value: string|null } })
 */
function RegimeSizingTemplate({ regimeSizing, onChange }) {
    const [enabled, setEnabled] = useState(false);
    const [values, setValues] = useState(EMPTY);

    useEffect(() => {
        if (regimeSizing) {
            try {
                const parsed = typeof regimeSizing === 'string' ? JSON.parse(regimeSizing) : regimeSizing;
                setValues({ ...EMPTY, ...parsed });
                setEnabled(true);
            } catch {
                setEnabled(false);
                setValues(EMPTY);
            }
        } else {
            setEnabled(false);
            setValues(EMPTY);
        }
    }, [regimeSizing]);

    function notify(newValues) {
        const hasAny = Object.values(newValues).some(v => v !== '' && v !== null);
        onChange({
            target: {
                id: 'regimeSizing',
                value: hasAny ? JSON.stringify(newValues) : null
            }
        });
    }

    function onToggle() {
        const next = !enabled;
        setEnabled(next);
        if (!next) {
            setValues(EMPTY);
            onChange({ target: { id: 'regimeSizing', value: null } });
        }
    }

    function onPctChange(key, raw) {
        const newValues = { ...values, [key]: raw };
        setValues(newValues);
        notify(newValues);
    }

    return (
        <div className='row mt-2'>
            <div className='col-12 mb-2'>
                <div className='form-check form-switch'>
                    <input className='form-check-input' type='checkbox' id='regimeSizingToggle'
                        checked={enabled} onChange={onToggle} />
                    <label className='form-check-label' htmlFor='regimeSizingToggle'>
                        Dimensionamento por Regime de Mercado
                    </label>
                    <small className='text-muted ms-2'>Ajusta o tamanho da ordem pelo regime de mercado (%)</small>
                </div>
            </div>
            {enabled && (
                <div className='col-12'>
                    <div className='row g-2'>
                        {REGIMES.map(r => (
                            <div className='col-6 col-md-3' key={r.key}>
                                <label className='form-label mb-1 small'>{r.label}</label>
                                <div className='input-group input-group-sm'>
                                    <input
                                        type='number'
                                        className='form-control'
                                        min='0'
                                        max='100'
                                        step='5'
                                        placeholder='—'
                                        value={values[r.key]}
                                        onChange={e => onPctChange(r.key, e.target.value)}
                                    />
                                    <span className='input-group-text'>%</span>
                                </div>
                                <small className='text-muted'>{r.hint}</small>
                            </div>
                        ))}
                    </div>
                    <small className='text-muted mt-1 d-block'>
                        Vazio = usar multiplicador padrão. 0% = ignorar ordem para esse regime.
                    </small>
                </div>
            )}
        </div>
    );
}

export default RegimeSizingTemplate;
